import { render, staticRenderFns } from "./EditUserPrivileges.vue?vue&type=template&id=24e1650a&scoped=true"
import script from "./EditUserPrivileges.vue?vue&type=script&lang=js"
export * from "./EditUserPrivileges.vue?vue&type=script&lang=js"
import style0 from "./EditUserPrivileges.vue?vue&type=style&index=0&id=24e1650a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24e1650a",
  null
  
)

export default component.exports